import { PSCType } from "@/graphql";
import store from "@/store";
import type { RouteRecordRaw } from "vue-router";
import { PSC_EVENT_INTERNAL_TYPES } from "./PSCEventTypes";

const router: RouteRecordRaw[] = [
  {
    path: "/psc",
    name: "PSC",
    redirect: {
      name: "PSCOverviews",
    },
    children: [
      {
        path: "overview",
        name: "PSCOverviews",
        redirect: {
          name: "PSCOverview",
          params: {
            type: PSCType.A3,
          },
        },
        children: [
          {
            path: "kaizen",
            name: "PSCOverviewKaizen",
            meta: {
              rights: ["psc.kaizenActive.read"],
            },
            redirect: {
              name: "PSCOverview",
              params: {
                type: PSCType.Kaizen,
              },
            },
          },
          {
            path: "archive",
            name: "PSCOverviewArchive",
            meta: {
              accessRightSome: true,
              rights: ["psc.pscInactive.read", "kaizen.kaizenInactive.read"],
            },
            redirect: {
              name: "PSCOverview",
              params: {
                type: PSCType.A3,
                archive: "true",
              },
            },
          },
          {
            path: ":type/:archive?",
            name: "PSCOverview",
            component: () => import("./views/PSCOverview.vue"),
            beforeEnter: (to) => {
              let right: string;

              if (to.params.archive === "true") {
                if (to.params.type === PSCType.Kaizen) {
                  right = "kaizen.kaizenInactive.read";
                } else {
                  right = "psc.pscInactive.read";
                }
              } else {
                if (to.params.type === PSCType.Kaizen) {
                  right = "kaizen.kaizenActive.read";
                } else {
                  right = "psc.pscActive.read";
                }
              }
              if (store.getters["login/hasAccessRight"](right)) {
                return true;
              }
              return { name: "pageNotFound" };
            },
            props: (route) => ({
              archive: route.params.archive === "true",
              type: route.params.type as PSCType,
            }),
          },
        ],
      },
      {
        path: "create/:type",
        name: "PSCCreate",
        component: () => import("./views/PSCCreate.vue"),
        meta: {
          rights: ["psc.pscActive.write", "kaizen.kaizenActive.write"],
        },
        beforeEnter: (to) => {
          if (
            store.getters["login/hasAccessRight"](
              to.params.type === PSCType.Kaizen
                ? "psc.pscActive.write"
                : "kaizen.kaizenActive.write",
            )
          ) {
            return true;
          }
          return { name: "pageNotFound" };
        },
        props: (route) => ({
          type: route.params.type,
          eventId: route.query.eventId ? Number(route.query.eventId) : undefined,
          eventType: route.query.eventType,
        }),
      },
      {
        path: "edit/:id",
        name: "PSCEdit",
        component: () => import("./views/PSCEdit.vue"),
        meta: {
          accessRightSome: true,
          rights: [
            "psc.pscActive.read",
            "kaizen.kaizenActive.read",
            "psc.pscInactive.read",
            "kaizen.kaizenInactive.read",
          ],
        },
        props: (route) => ({
          id: Number(route.params.id),
        }),
      },
      {
        path: "configOverview",
        name: "PSCConfigOverview",
        component: () =>
          import("@/modules/sqdc/components/eventActionConfig/SQDCEventActionTypeConfigOverview.vue"),
        meta: {
          rights: ["psc.admin"],
        },
        props: {
          internalTypes: [...PSC_EVENT_INTERNAL_TYPES],
          titleKey: "router.PSCConfigOverview",
          detailRouteName: "PSCConfigSettings",
        },
      },
      {
        path: "configOverview/:siteId",
        name: "PSCConfigSettings",
        component: () =>
          import("@/modules/sqdc/components/eventActionConfig/SQDCEventActionTypeConfigSettings.vue"),
        meta: {
          rights: ["psc.admin"],
        },
        props: (route) => ({
          internalTypes: [...PSC_EVENT_INTERNAL_TYPES],
          configureAllEventConversionSources: true,
          siteId: Number(route.params.siteId),
          titleKey: "router.PSCConfigSettings",
        }),
      },
    ],
  },
];

export default router;
